import { Card } from "../../models/card";
export class PurpleGem extends Card {
}
PurpleGem.displayName = "Purple Gem";
PurpleGem.artUrl = "./assets/cards/purplegem.jpg";
